<template>
  <div v-loading="loading" class="card">
    <div class="title">报警规则</div>
    <!-- 温度报警 -->
    <el-row class="tool-row" align="middle" style="margin-top: 10px">
      <el-col :span="5" style="font-weight:bold"> 温度报警规则（℃） </el-col>
    </el-row>
    <el-row class="tool-row" align="middle" style="margin-top: 10px">
      <el-col :span="3"> 高温报警 </el-col>
      <el-col :span="2">
        <el-input-number
          v-model="temHigh"
          size="small"
          :controls="false"
          :min="temLow"
        ></el-input-number>
      </el-col>
      <el-col :span="3" :offset="2"> 低温报警 </el-col>
      <el-col :span="2">
        <el-input-number
          v-model="temLow"
          size="small"
          :controls="false"
          :max="temHigh"
        ></el-input-number>
      </el-col>
    </el-row>
    <!-- 湿度报警 -->
    <el-row class="tool-row" align="middle" style="margin-top: 10px">
      <el-col :span="5" style="font-weight:bold"> 湿度报警规则（%） </el-col>
    </el-row>
    <el-row class="tool-row" align="middle" style="margin-top: 10px">
      <el-col :span="3"> 高湿报警 </el-col>
      <el-col :span="2">
        <el-input-number
          v-model="rhHigh"
          size="small"
          :controls="false"
          :min="rhLow"
        ></el-input-number>
      </el-col>
      <el-col :span="3" :offset="2"> 低湿报警 </el-col>
      <el-col :span="2">
        <el-input-number
          v-model="rhLow"
          size="small"
          :controls="false"
          :max="rhHigh"
        ></el-input-number>
      </el-col>
    </el-row>
    <!-- 气体报警 -->
    <el-row class="tool-row" align="middle" style="margin-top: 10px">
      <el-col :span="5" style="font-weight:bold"> 气体报警规则（ppm） </el-col>
    </el-row>
    <el-row class="tool-row" align="middle" style="margin-top: 10px">
      <el-col :span="3"> 报警阈值 </el-col>
      <el-col :span="2">
        <el-input-number
          v-model="gasHigh"
          size="small"
          :controls="false"
          :min="0"
        ></el-input-number>
      </el-col>
    </el-row>
    <!-- 修改按钮 -->
    <el-row class="tool-row" align="middle">
      <el-col :span="2">
        <el-button @click="update" type="primary" disabled>修改</el-button>
      </el-col>
    </el-row>
  </div>
</template>
    
<script setup>
import { useBarnStore } from "@/stores/barn";
import { queryWarningRuleAPI, updateWarningRuleAPI } from "@/apis/warningManageAPI";
import { onMounted, ref, watch } from "vue";

//获取畜舍id
const barnStore = useBarnStore();

//接收数据
const ruleId = ref(0);
const temHigh = ref(0);
const temLow = ref(0);
const rhHigh = ref(0);
const rhLow = ref(0);
const gasHigh = ref(0);

const deviceName = ref("");

//等待加载
const loading = ref(false)

//参数相关
const queryWarningRule = async () => {
  loading.value = true;
  const { data } = await queryWarningRuleAPI(barnStore.barnId);
  ruleId.value = data.id;
  deviceName.value = data.deviceName;
  temHigh.value = data.temHigh;
  temLow.value = data.temLow;
  rhHigh.value = data.rhHigh;
  rhLow.value = data.rhLow;
  gasHigh.value = data.gasHigh;
  loading.value = false;
};
const updateWarningRule = async () => {
  const {data} = await updateWarningRuleAPI({
    id: ruleId.value,
    deviceName: deviceName.value,
    temHigh:temHigh.value,
    temLow:temLow.value,
    rhHigh:rhHigh.value,
    rhLow:rhLow.value,
    gasHigh:gasHigh.value,
  })
}

//按钮赋值
const update = () => {
  updateWarningRule();
};
//数据初始化
queryWarningRule();

//页面刷新函数
onMounted(() => {
  watch(
    () => barnStore.barnId,
    () => {
      queryWarningRule();
    }
  );
});
</script>
    
<style scoped lang="less">
.card {
  width: 100%;
  min-height: 550px;
  background-color: white;
  .title {
    font-family: @title;
    font-weight: bold;
    font-size: 22px;
    height: 30px;
    line-height: 30px;
    padding-top: 20px;
    padding-left: 35px;
  }
  .tool-row {
    width: 850px;
    height: 40px;
    left: 35px;
    margin-top: 15px;
    font-size:16px;
    :deep(.el-input-number--small) {
      width: 80px;
    }
  }
}
</style>